import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const TotalUsers = () => {
    const { analytics, isLoading, defaultData } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='Total Users'
            percentageDifference={
                analytics ? analytics.totalUsers.dailyDiffPercentage.toString() : '0'
            } // hardcode positive value to make positive chart
            amount={formatUSD(analytics?.totalUsers.currentValue.toString() || '0', {
                maxDecimals: 0,
                currency: '',
            })}
            data={analytics?.totalUsers.historicalData ?? defaultData}
            isLoading={isLoading}
        />
    );
};

export default TotalUsers;
